<template>
  <div class="container about-game">
    <h1 class="title">Game rules</h1>
    <h2>Overview</h2>
    <p>
      MonkeyBattle works similarly to other card games such as Hearthstone -
      each round, you get some potassium which you can use to play cards from
      your deck that are randomly drawn into your hand. The cards are either
      creatures, which are played on the board and have attack and health but
      can only be used in the next turn or spells, which are single use cards
      with immediate effects. The ultimate goal is to attack the opponent's
      CryptomonKey until it is at 0 health and you win the game. Your monkey
      also takes damage each turn if you run out of cards in your deck.
    </p>
    <h2>NFTs and Deck Building</h2>
    <p>
      Apart from a base set of cards, the game also includes NFTs from the
      banano community which are playable in-game items! If you own them, they
      should show up in the deck builder automatically. You can create and
      customize decks to fit your play style and discover strategic combinations
      of cards!
    </p>
    <div class="images">
      <img src="@/assets/images/annotated1.png" alt="" />
      <img src="@/assets/images/annotated2.png" alt="" />
    </div>
    <h2>Special card properties</h2>
    <div class="specials">
      <div>
        Blocker ✋ - when a blocker is on the board, other creatures must target
        them and cannot attack other cards. Spells can bypass this.
      </div>
      <div>
        High 🌿 - Creatures who are high won't always attack your selected
        target
      </div>
      <div>
        Monkeshield 🛡️ - This gives a creature protection the first time they
        take damage
      </div>
      <div>
        FUD 😨 - Creatures with FUD lose health at the end of each round
      </div>
      <div>Camo 🙈 - Creatures with camo cannot be targeted in attacks</div>
      <div>
        Instant - An immediately usable effect a creature has on being played
      </div>
    </div>
    <h2>Classes</h2>
    <p>
      Apart from a base set of neutral cards, there are three classes of cards
      which can only be added to a deck if they match the class of the
      CryptomonKey. They are divided into Memes, Movies+TV, and Festive.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "About",
});
</script>

<style scoped>
h1 {
  text-align: center;
  color: var(--yellow-primary);
  margin-top: 2rem;
}

.about-game {
  max-width: 1000px;
}

h1,
h2,
p,
img,
div {
  margin-bottom: 1rem;
}

.images {
  text-align: center;
}

img {
  max-width: 100%;
  margin: auto;
  border: 1px solid;
  border-color: var(--yellow-primary);
}
</style>
